/* eslint-disable consistent-return */
// Todo: remove eslint and fix the test
import axios from 'axios'
import { AllowedHttpMethods, authenticationApiConfig } from '../apiList'
import { AuthenticatedUser } from '../../../types/Login/authenticationTypes'

const authenticateUser = async (
  username: string,
  password: string,
  tenantKey: string,
): Promise<{ authenticatedUser: AuthenticatedUser } | undefined> => {
  const response = await axios({
    url: authenticationApiConfig.login,
    method: AllowedHttpMethods.post,
    headers: {
      tenantKey,
      'Content-Type': 'application/json',
    },
    data: { username, password },
  })
  if (response.status === 200) {
    const data = {
      authenticatedUser: {
        employeeName: `${response.data.employeeDto.firstName} ${response.data.employeeDto.lastName}`,
        employeeId: response.data.employeeDto.id,
        userName: response.data.employeeDto.userName,
        role: response.data.employeeDto.role,
        tenantKey: response.data.tenantKey,
        token: response.data.employeeDto.token,
        designation: response.data.employeeDto.designation,
        country: response.data.employeeDto.country,
        workLocation: response.data.employeeDto.workLocation,
      },
    }

    const vendorData = {
      authenticatedUser: {
        vendorName: response.data.employeeDto.vendorName,
        vendorEmployeeId: response.data.employeeDto.vendorEmployeeId,
        userName: response.data.employeeDto.userName,
        role: response.data.employeeDto.role,
        tenantKey: response.data.tenantKey,
        vendorActualName: response.data.employeeDto.vendorActualName,
      },
    }
    const useVendorData = !!response.data.employeeDto.vendorId

    localStorage.setItem('employeeName', data.authenticatedUser.employeeName)
    localStorage.setItem(
      'employeeId',
      data.authenticatedUser.employeeId ??
        vendorData.authenticatedUser.vendorEmployeeId,
    )
    localStorage.setItem(
      'userName',
      data.authenticatedUser.userName ?? vendorData.authenticatedUser.userName,
    )
    localStorage.setItem(
      'role',
      data.authenticatedUser.role ?? vendorData.authenticatedUser.role,
    )
    localStorage.setItem(
      'tenantKey',
      data.authenticatedUser.tenantKey ??
        vendorData.authenticatedUser.tenantKey,
    )
    localStorage.setItem('token', data.authenticatedUser.token)
    localStorage.setItem('designation', data.authenticatedUser.designation)
    localStorage.setItem('employeeCountry', data.authenticatedUser.country)
    //
    localStorage.setItem('isVendor', useVendorData.toString())
    localStorage.setItem('vendorName', vendorData.authenticatedUser.vendorName)
    localStorage.setItem(
      'vendorUserName',
      vendorData.authenticatedUser.userName,
    )

    localStorage.setItem(
      'vendorEmployeeId',
      vendorData.authenticatedUser.vendorEmployeeId || '',
    )
    localStorage.setItem(
      'vendorActualName',
      vendorData.authenticatedUser.vendorActualName || '',
    )

    return data
  }
}

const authenticationApi = { authenticateUser }

export default authenticationApi
